module.exports = __webpack_public_path__ + "media/map.27a6e999.svg";